import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? ((window.location.hostname === 'devapp.soviewfx.fr' || window.location.hostname === 'devadmin.soviewfx.fr') ? 'https://devhub.soviewfx.fr' : ((window.location.hostname === 'app.soviewfx.fr' || window.location.hostname === 'admin.soviewfx.fr') ? 'https://hub.soviewfx.fr' : '')) : '');

export default function EmailConfirm() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const confirmEmail = async () => {
      // Extract token from hash
      const hash = window.location.hash;
      const match = hash.match(/confirm_email=([^&]+)/);
      
      if (!match) {
        setStatus('error');
        setMessage('Token invalide');
        return;
      }
      
      const token = match[1];
      
      try {
        const response = await fetch(`${API_URL}/api/auth/confirm-email?token=${token}`, {
          method: 'POST'
        });
        
        if (response.ok) {
          setStatus('success');
          setMessage('Email confirmé avec succès !');
        } else {
          const err = await response.json();
          setStatus('error');
          setMessage(err.detail || 'Erreur de confirmation');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Erreur de connexion');
      }
    };
    
    confirmEmail();
  }, []);
  
  const handleContinue = () => {
    // Clear hash and redirect
    window.history.replaceState(null, '', window.location.pathname);
    navigate('/home');
  };
  
  return (
    <div className="h-full w-full flex items-center justify-center bg-background p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="glass-light rounded-2xl p-8 text-center max-w-sm w-full"
      >
        {status === 'verifying' && (
          <>
            <div className="spinner mx-auto mb-4" />
            <p className="text-white font-bold">Vérification en cours...</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-500/20 rounded-full mx-auto mb-4 flex items-center justify-center">
              <CheckCircle size={40} className="text-green-500" />
            </div>
            <h2 className="text-xl font-bold text-white mb-2">Email confirmé !</h2>
            <p className="text-muted-foreground mb-6">{message}</p>
            <button
              onClick={handleContinue}
              className="w-full btn-primary"
              data-testid="continue-btn"
            >
              Continuer
            </button>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-500/20 rounded-full mx-auto mb-4 flex items-center justify-center">
              <XCircle size={40} className="text-red-500" />
            </div>
            <h2 className="text-xl font-bold text-white mb-2">Erreur</h2>
            <p className="text-muted-foreground mb-6">{message}</p>
            <button
              onClick={handleContinue}
              className="w-full btn-secondary"
              data-testid="back-btn"
            >
              Retour à l'accueil
            </button>
          </>
        )}
      </motion.div>
    </div>
  );
}
